import { useState } from "react";
import { Form, Input, Button, notification, Checkbox } from "antd";

import { useAuth } from "../../context/auth";

export default function LoginForm(props) {
  const { login } = useAuth();

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);

    const url = new URL('/api/auth/login', window.location);
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        email: values.username,
        pass: values.password,
        type: 'admin',
      }),
    });
    const data = await res.json();

    switch (data.message) {
      case 'Success':
        await login(data.accessToken, data.adminRole, values.remember);
        break;

      case 'user':
      case 'pass':
        notification["error"]({
          message: "Login Fail!",
          description: "Username or Password isn't correct.",
        });
        break;

      default:
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${data.message})`,
        });
    }

    setLoading(false);
  };

  return (
    <>
      <div className="text-2xl">
        Welcome to <span style={{ color: "#30D3DE" }}>EV Charging System</span>
      </div>
      <div className="grid justify-center">
        <div className="text-6xl mt-6 mb-12">Login Account</div>
        <Form
          form={form}
          className="w-102"
          layout="vertical"
          onFinish={onFinish}
          requiredMark={"optional"}
        >
          <Form.Item
            name="username"
            label={<span className="text-xl font-medium">Username</span>}
            rules={[{ required: true, message: "Username is required." }]}
          >
            <Input
              className="rounded-lg"
              size="large"
              placeholder="Enter your username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            label={<span className="text-xl font-medium">Password</span>}
            rules={[{ required: true, message: "Password is required." }]}
          >
            <Input.Password
              className="rounded-lg"
              size="large"
              placeholder="Enter your password"
            />
          </Form.Item>
          <Form.Item
            name="remember"
            valuePropName="checked"
          >
            <div className="flex">
              <div className="flex-1">
                <Checkbox>
                  Remember me
                </Checkbox>
              </div>
              <div
                className="underline cursor-pointer hover:opacity-80"
                onClick={() =>
                  props.setCurrentPageAction({
                    name: "Forgot Password?",
                    mail: "",
                  })
                }
              >
                Forgot Password?
              </div>
            </div>
          </Form.Item>
          <Form.Item className="flex float-right">
            <Button
              className="w-52 flex items-center justify-center"
              size="large"
              shape="round"
              loading={loading}
              type="primary"
              htmlType="submit"
            >
              Log in
            </Button>
          </Form.Item>
          {/* <div className="w-full mt-2 text-sm text-center">
          ©2020 PTT Public Company Limited <br />
          <strong> v.{version}</strong> 
        </div> */}
        </Form>
      </div>
    </>
  );
}
